import { Groupe } from "./groupe.model";

export class Equivalence {
  equivalenceId: number;
  isIdentique: boolean;
  fromGroupeId: number;
  toGroupeId: number;
  ordre: number;
  fromGroupe: Groupe[];
  toGroupe: Groupe[];
}
